/**
 * Collection page behaviour for sections/dorahi-collection.liquid.
 * Port of the client bits of filter-sidebar.tsx and sort-dropdown.tsx:
 *
 *  - desktop sort dropdown opens on hover
 *  - mobile sort sheet / filter drawer open on the same open-sort /
 *    open-filter window events the app's bottom nav dispatched
 *  - filter sections collapse/expand (all expanded by default)
 *  - the mobile filter drawer keeps a temp selection and only navigates on
 *    Apply, mirroring MobileFilterButton
 */
(function () {
  if (window.__dorahiCollectionBound) return;
  window.__dorahiCollectionBound = true;

  const show = (el) => el && el.classList.remove("hidden");
  const hide = (el) => el && el.classList.add("hidden");

  /* Desktop sort: open on hover, like onMouseEnter/onMouseLeave. */
  const desktopSort = document.querySelector("[data-sort-desktop]");
  if (desktopSort) {
    const menu = desktopSort.querySelector("[data-sort-desktop-menu]");
    desktopSort.addEventListener("mouseenter", () => show(menu));
    desktopSort.addEventListener("mouseleave", () => hide(menu));
  }

  /* Mobile sheets, opened from the bottom nav events. */
  const sortMobile = document.querySelector("[data-sort-mobile]");
  const filterMobile = document.querySelector("[data-filter-mobile]");

  window.addEventListener("open-sort", () => show(sortMobile));
  window.addEventListener("open-filter", () => {
    // Reset temp filters to current URL state when opening, like the app.
    filterMobile?.querySelectorAll("[data-filter-checkbox]").forEach((box) => {
      box.checked = box.hasAttribute("checked");
    });
    updateTempCount();
    show(filterMobile);
  });

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (
      target.closest("[data-sort-mobile-close]") ||
      target.closest("[data-sort-mobile-backdrop]")
    )
      hide(sortMobile);
    if (
      target.closest("[data-filter-mobile-close]") ||
      target.closest("[data-filter-mobile-backdrop]")
    )
      hide(filterMobile);

    const sectionToggle = target.closest("[data-filter-section-toggle]");
    if (sectionToggle) {
      const section = sectionToggle.closest("[data-filter-section]");
      const body = section?.querySelector("[data-filter-section-body]");
      const chevron = section?.querySelector("[data-filter-chevron] svg");
      if (body) {
        const collapsed = body.classList.toggle("hidden");
        chevron?.classList.toggle("rotate-180", !collapsed);
      }
      return;
    }

    if (target.closest("[data-filter-clear]")) {
      filterMobile
        ?.querySelectorAll("[data-filter-checkbox]")
        .forEach((box) => {
          box.checked = false;
        });
      updateTempCount();
      return;
    }

    const apply = target.closest("[data-filter-apply]");
    if (apply instanceof HTMLElement) {
      // Search keeps ?q= alongside the filters; collections have no extras.
      const params = new URLSearchParams(apply.dataset.extraParams || "");
      filterMobile
        ?.querySelectorAll("[data-filter-checkbox]")
        .forEach((box) => {
          if (box.checked)
            params.append(box.dataset.paramName, box.dataset.paramValue);
        });
      if (
        apply.dataset.sortBy &&
        apply.dataset.sortBy !== apply.dataset.defaultSort
      ) {
        params.set("sort_by", apply.dataset.sortBy);
      }
      const query = params.toString();
      window.location.href =
        apply.dataset.collectionUrl + (query ? `?${query}` : "");
    }
  });

  const updateTempCount = () => {
    if (!filterMobile) return;
    const count = filterMobile.querySelectorAll(
      "[data-filter-checkbox]:checked",
    ).length;
    const label = count > 0 ? `(${count})` : "";
    const headerCount = filterMobile.querySelector("[data-filter-count]");
    if (headerCount) headerCount.textContent = label;
    const applyCount = filterMobile.querySelector("[data-filter-apply-count]");
    if (applyCount) applyCount.textContent = label;
    const clear = filterMobile.querySelector("[data-filter-clear]");
    clear?.classList.toggle("hidden", count === 0);
  };

  filterMobile?.addEventListener("change", (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest("[data-filter-checkbox]")
    )
      updateTempCount();
  });
})();
